<template>
  <div class="jj-form">
    <!-- <div class="tips-text">(企业注册时间超过三年必须填写最近三年经济数据，企业注册时间不足三年，请填写注册当年到去年所有数据)</div> -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in formList"
        :key="index"
        :label="item.name"
        :name="item.value"
      >
      </el-tab-pane>
      <el-row :gutter="0">
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="small"
          label-width="165px"
        >
          <el-col :span="8">
            <el-form-item label="资产投入" prop="yysr">
              <el-input
                v-model="formData.yysr"
                placeholder="请输入资产投入(万元)"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="信息化投入(万元)" prop="zyywsr">
              <el-input
                v-model="formData.zyywsr"
                placeholder="请输入信息化投入(万元)"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生产管理软件(万元)" prop="xssr">
              <el-input
                v-model="formData.xssr"
                placeholder="请输入生产管理软件(万元)"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="办公自动化软件" prop="jlr">
              <el-input
                v-model="formData.jlr"
                placeholder="请输入办公自动化软件投入"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电脑设备" prop="jzc">
              <el-input
                v-model="formData.jzc"
                placeholder="请输入电脑设备投入"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机器设备投入（技改）" prop="zzc">
              <el-input
                v-model="formData.zzc"
                placeholder="请输入机器设备投入（技改）投入"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机器类投入" prop="ckze">
              <el-input
                v-model="formData.ckze"
                placeholder="请输入机器类投入"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仪器类投入" prop="jkze">
              <el-input
                v-model="formData.jkze"
                placeholder="请输入仪器类投入"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="节能减排类设备投入" prop="fzze">
              <el-input
                v-model="formData.fzze"
                placeholder="请输入节能减排类设备投入"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品牌推广费用" prop="ml">
              <el-input
                v-model="formData.ml"
                placeholder="请输入品牌推广费用"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="研发费用" prop="yftl">
              <el-input
                v-model="formData.yftl"
                placeholder="请输入研发费用"
                clearable
                :style="{ width: '100%' }"
                :disabled="tijBtnShow == false"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item size="large">
              <el-button
                v-show="tijBtnShow == true"
                type="primary"
                @click="submitForm"
              >{{
                  formData.year &&
                  formData.year == 2020 - parseInt(activeName) &&
                  formData.id
                    ? "修改"
                    : "新建"
                }}</el-button
              >
              <el-button @click="tijBtnShow = !tijBtnShow" type="danger">{{
                  tijBtnShow ? "取消" : "编辑"
                }}</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-tabs>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: [],
  data() {
    return {
      /* tabs */
      activeName: "0",
      /* 是否编辑 */
      tijBtnShow: false,
      /* 获取的列表信息 */
      formList: [
        {
          value: "0",
          name: "2020",
        },
        {
          value: "1",
          name: "2019",
        },
        {
          value: "2",
          name: "2018",
        },
      ],
      /* 展示参数 */
      formData: {
        yysr: 0,
        zyywsr: 0,
        xssr: 0,
        jlr: 0,
        jzc: 0,
        zzc: 0,
        ckze: 0,
        jkze: 0,
        fzze: 0,
        ml: 0,
        yftl: 0,
        zdxmtz: 0,
        nsze: 0,
        qnsze: 0,
        nszm: "健康长寿",
        qysds: 0,
        zzs: 0,
        yysr: 0,
        zrsds: 0,
        qts: 0,
        bz: "新年新气象",
        createTime: "",
        updateTime: "",
        // webEid: '',
        year: "", // 年份
      },
      /* 暂存三年的 */
      threeYearData: [{}, {}, {}],
      newData: {
        yysr: "",
        zyywsr: "",
        xssr: "",
        jlr: "",
        jzc: "",
        zzc: "",
        ckze: "",
        jkze: "",
        fzze: "",
        ml: "",
        yftl: "",
        zdxmtz: "",
        nsze: "",
        qnsze: "",
        nszm: "",
        qysds: "",
        zzs: "",
        yysr: "",
        zrsds: "",
        qts: "",
        bz: "",
        createTime: "",
        updateTime: "",
        // webEid: '',
        year: "", // 年份
      },
      /* 获取的所有列表参数 */
      allFormList: [],
      rules: {
        yysr: [
          {
            required: true,
            message: "请输入营业收入(万元)",
            trigger: "blur",
          },
        ],
        zyywsr: [],
        xssr: [
          {
            required: true,
            message: "请输入销售收入(万元)",
            trigger: "blur",
          },
        ],
        jlr: [
          {
            required: true,
            message: "请输入净利润",
            trigger: "blur",
          },
        ],
        jzc: [
          {
            required: true,
            message: "请输入净资产",
            trigger: "blur",
          },
        ],
        zzc: [
          {
            required: true,
            message: "请输入总资产",
            trigger: "blur",
          },
        ],
        ckze: [],
        jkze: [
          {
            required: true,
            message: "请输入进口总额",
            trigger: "blur",
          },
        ],
        fzze: [
          {
            required: true,
            message: "请输入负债总额",
            trigger: "blur",
          },
        ],
        ml: [
          {
            required: true,
            message: "请输入毛利",
            trigger: "blur",
          },
        ],
        yftl: [
          {
            required: true,
            message: "请输入研发投入",
            trigger: "blur",
          },
        ],
        zdxmtz: [],
        nsze: [
          {
            required: true,
            message: "请输入纳税总额",
            trigger: "blur",
          },
        ],
        qnsze: [
          {
            required: true,
            message: "请输入区纳税总额",
            trigger: "blur",
          },
        ],
        nszm: [],
        qysds: [],
        zzs: [],
        yysr: [],
        zrsds: [],
        qts: [],
        bz: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      accountId: "getAccountId",
    }),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    /**
     * 新建经济指标
     */
    addJJZB() {
      this.tijBtnShow = false;
    },
    /**
     * 修改
     */
    upJJZB() {
      this.tijBtnShow = false;
    },
    /**
     * tabs 切换
     */
    handleClick(tab, event) {
      console.log("切换>>>", tab.label, event);
      const e = parseInt(tab.index);
      this.formData = this.threeYearData[e]; // 初始
      this.formData.year = tab.label;
    },
    /**
     * 提交按钮
     */
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        // TODO 提交表单
        if (this.formData.id) {
          this.upJJZB();
        } else {
          this.addJJZB();
        }
      });
    },
    /**
     * 重置按钮
     */
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.jj-form {
}
.tips-text {
  // position: absolute;
  right: 0;
  top: 18px;
}
</style>
<style lang="scss">
.jj-form {
  .el-tabs__nav {
    height: 40px !important;
  }
}
</style>
